export const COEFFICIENTS = {
  age: -0.0371,
  sex: 0.2210,
  eGFR: -0.0415,
  hemo: -0.0136,
  albuminuriaMild: 0.3607,
  albuminuriaHeavy: 0.7245,
  diabetes: 0.2622,
  priorInv: -0.0314,
  interTerm: -6.711
};

export const BASELINES = {
  age: -73.62,
  eGFR: -51.12,
  hemo: -130.95
};

export const FACTOR = {
  conservativeMgmt: 1 / 1.20
};
